export default {
      id: "location-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#location",
      toString: function () {
        return this.url;
      }
    }